import css from 'styled-jsx/css';

const styles = theme => {
  return css.resolve`
    .no-results {
      line-height: 20px;
      display: flex;
      flex-direction: column;
      height:50vh;
      justify-content: center;
    }

    .no-results-texts {
      margin-top: 50px;
    }

    .no-results-title {
      color: ${theme.titleColor};
      padding: 0px 0px;
    }
  `;
};
export default styles;
